/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface JobFeedbackUpdateRequest {
  sentiment: JobFeedbackUpdateRequest.SentimentEnum;
  topics: Array<string>;
  comment?: string;
  potentialImpact: JobFeedbackUpdateRequest.PotentialImpactEnum;
  performedBy?: string;
  suggestedImprovement?: string;
}
export namespace JobFeedbackUpdateRequest {
  export const SentimentEnum = {
    NotGood: 'NOT_GOOD',
    Neutral: 'NEUTRAL',
    Good: 'GOOD',
  } as const;
  export type SentimentEnum = (typeof SentimentEnum)[keyof typeof SentimentEnum];
  export const PotentialImpactEnum = {
    None: 'NONE',
    ScheduleProgress: 'SCHEDULE_PROGRESS',
    Cost: 'COST',
    Hms: 'HMS',
    Quality: 'QUALITY',
    Unsure: 'UNSURE',
  } as const;
  export type PotentialImpactEnum = (typeof PotentialImpactEnum)[keyof typeof PotentialImpactEnum];
}
